import { Swiper as Sp, SwiperSlide } from "swiper/react"
import { Container, Row } from "react-bootstrap"
import SwiperCore, { Autoplay } from "swiper"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/autoplay"

type SwiperProps = {
  title: string
  slidesPerView: number
  images: string[]
  headingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6"
}

type DynamicHeadingProps = {
  level?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6"
  children: React.ReactNode
  style?: React.CSSProperties
}

const DynamicHeading: React.FC<DynamicHeadingProps> = ({
  level = "h4",
  children,
  style,
}) => {
  const Tag = level as keyof JSX.IntrinsicElements
  return <Tag style={style}>{children}</Tag>
}

const Swiper: React.FC<SwiperProps> = ({
  title,
  slidesPerView,
  images,
  headingLevel,
}) => {
  SwiperCore.use([Autoplay])

  return (
    <Container fluid>
      <Row>
        <DynamicHeading
          level={headingLevel}
          style={{
            textAlign: "center",
            color: "var(--fiva-color)",
            margin: "1em 0em",
            fontSize:"2rem"
          }}
        >
          {title}
        </DynamicHeading>
        <Sp
          breakpoints={{
            550: {
              slidesPerView: 2,
            },
            700: {
              slidesPerView: 4,
            },
            1400: {
              slidesPerView: slidesPerView,
            },
          }}
          spaceBetween={50}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          modules={[Autoplay]}
          loop={true}
        >
          {images?.map((image, index) => (
            <SwiperSlide
              key={index}
              style={{
                minHeight: "20vh",
                backgroundImage: `url(${image})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "contain",
              }}
            />
          ))}
        </Sp>
      </Row>
    </Container>
  )
}

export default Swiper
